import * as angular from 'angular';

import { SelectOption } from '../../select-field/select-field.component';
import { TableListAction } from '../table-list-action/table-list-action.type';
import { TableListCell } from '../lib/table-list-cell';

class TableListRowController {
  private actions!: TableListAction[];
  private data: TableListCell[] = [];
  private options!: SelectOption[];
  private dropdownEnabled!: boolean;
  private hasLink!: boolean;
  private onActionSelect!: ($args: { $selection: TableListAction }) => void;
  private onSelect!: ($args: { $option: SelectOption; $options: Object }) => void;

  handleActionSelection($event: Event, $selection: TableListAction) {
    $event.stopPropagation();

    this.onActionSelect({ $selection });
  }

  handleDropdownClick($event: Event) {
    $event.stopPropagation();
  }

  handleSelection($option: SelectOption, $options: Object) {
    this.onSelect({ $option, $options });
  }

  displayChevron(): boolean {
    return this.hasLink && !this.dropdownEnabled;
  }
}

export const TableListRowComponent: angular.IComponentOptions = {
  controller: TableListRowController,
  controllerAs: 'ctrl',
  bindings: {
    actions: '<',
    actionsEnabled: '<',
    data: '<',
    dropdownEnabled: '<',
    dropdownTooltipMessage: '<',
    dropdownTooltipEnabled: '<',
    hasLink: '<',
    onActionSelect: '&',
    onSelect: '&',
    options: '<',
  },
  transclude: true,
  template: `
    <div class="row-wrapper" ng-transclude>
      <table-list-cell
        ng-repeat="cell in ctrl.data track by $index"
        column="{{cell.field}}"
        tooltip="cell.tooltip"
        value="cell.value"
      />
      <table-list-cell column="actions" ng-if="ctrl.actionsEnabled">
        <ul class="row-actions">
          <li class="row-action" ng-class="{ 'force-visible': action.forceVisibility }"ng-repeat="action in ctrl.actions">
            <a
              class="row-action-link"
              ng-if="action.href"
              ng-href="{{ action.href }}"
              ng-click="ctrl.handleActionSelection($event, action)"
              target="{{ action.hrefTarget || '_self' }}"
            >
              <capra-icon class="sm2-icon action-icon" [icon]="action.icon"></capra-icon>
              <capra-icon class="sm2-icon action-icon-hover" [icon]="action.iconHover || action.icon"></capra-icon>
            </a>
            <button
              class="row-action-btn"
              ng-if="!action.href"
              ng-click="ctrl.handleActionSelection($event, action)"
            >
              <capra-icon class="sm2-icon action-icon" ng-class="{'filled': action.icon === 'icon-star-filled'}" [icon]="action.icon"></capra-icon>
              <capra-icon class="sm2-icon action-icon-hover" ng-class="{'filled': action.icon === 'icon-star-filled'}" [icon]="action.iconHover || action.icon"></capra-icon>
            </button>
          </li>
        </ul>
      </table-list-cell>
      <table-list-cell column="dropdown" ng-if="ctrl.dropdownEnabled">
        <table-list-row-dropdown
          ng-click="ctrl.handleDropdownClick($event)"
          options="ctrl.options"
          on-select="ctrl.handleSelection($option, $options)"
          dropdown-tooltip-message="ctrl.dropdownTooltipMessage"
          dropdown-tooltip-enabled="ctrl.dropdownTooltipEnabled"
        />
      </table-list-cell>
      <table-list-cell ng-if="ctrl.displayChevron()" class="link--arrow-icon-cell">
        <capra-icon class="align-md-icon capra--arrow-icon" icon="icon-chevron-right"></capra-icon>
      </table-list-cell>
    </div>
  `,
};
